import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { NgxCurrencyDirective } from 'ngx-currency';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { MaskService } from '@shared/services/mask.service';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';

/**
 * Seção "Retenções na fonte" da aba Totais. O cartão de ativação expande os campos.
 *
 * Os campos de base de cálculo e alíquotas são a base visual desta etapa; ainda não
 * há colunas no banco para persistí-los, então apenas o flag "retencaoFonteAtivo" é
 * salvo. Os demais controles existem no FormGroup mas não são mapeados no request.
 */
@Component({
    selector: 'app-totais-retencoes-fonte-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        NgxCurrencyDirective,
        AtivacaoSectionCardComponent,
    ],
    templateUrl: './retencoes-fonte-section.component.html',
    styleUrl: './retencoes-fonte-section.component.css',
})
export class RetencoesFonteSectionComponent {
    @Input({ required: true }) form!: FormGroup;
    @Input() tiposBaseCalculo: LookupItemStruct[] = [];

    public readonly percentMask = this.maskService.getPercentMask();
    public readonly currencyMask = this.maskService.getCurrencyMask();

    constructor(private maskService: MaskService) { }

    public get ativoControl(): FormControl {
        return this.form.get('retencaoFonteAtivo') as FormControl;
    }
}
